<template>
  <div class="orderDetail">
    <div class="orderConter">
      <div class="header">
        <div class="headerTit">
          <div class="title">{{formData.productName}}</div>
        </div>
        <div class="state" :class="{'rechargeStatus': formData.rechargeStatusName === '处理中'}">{{formData.rechargeStatusName}}</div>
      </div>
      
      <div class="orderBottom">
        <div class="number">
          <div class="num">罚款￥{{formData.punishAmount}}  记{{formData.punishPoint}}分</div>
          <div class="content noBorder">
            <van-row>
              <van-col span="7" class="textNo">违法原因：</van-col>
              <van-col span="17" class="textVal">{{formData.violationReason}}<span v-if="!formData.violationReason" class="hidden">无</span></van-col>
              <van-col span="7" class="textNo">违法地点：</van-col>
              <van-col span="17" class="textVal">{{formData.violationAddr}}<span v-if="!formData.violationAddr" class="hidden">无</span></van-col>
              <van-col span="7" class="textNo">违法时间：</van-col>
              <van-col span="17" class="textVal textHeight">{{formData.punishDate}}</van-col>
            </van-row>
          </div>
        </div>
        <div class="orderInfo">
          <van-row justify="space-between">
            <van-col span="12" class="text">车牌号码</van-col>
            <van-col span="12" class="textRight">{{formData.carNo}}<span v-if="!formData.carNo" class="hidden">无</span></van-col>
            <van-col span="12" class="text">号牌类型</van-col>
            <van-col span="12" class="textRight">{{formData.numberPlateType}}<span v-if="!formData.numberPlateType" class="hidden">无</span></van-col>
            <van-col span="8" class="text">车架号码</van-col>
            <van-col span="16" class="textRight">{{formData.vinNo}}<span v-if="!formData.vinNo" class="hidden">无</span></van-col>
            <van-col span="8" class="text">发动机号</van-col>
            <van-col span="16" class="textRight">{{formData.engineNo}}<span v-if="!formData.engineNo" class="hidden">无</span></van-col>
            <van-col span="8" class="text">车主号码</van-col>
            <van-col span="16" class="textRight">{{formData.contactPhone}}<span v-if="!formData.contactPhone" class="hidden">无</span></van-col>
            <van-col span="8" class="text" v-if="formData.drivingLicense">驾驶证号</van-col>
            <van-col span="16" class="textRight" v-if="formData.drivingLicense">{{formData.drivingLicense}}</van-col>
            <van-col span="9" class="text" v-if="formData.drivingLicenseFile">驾驶证档案编号</van-col>
            <van-col span="15" class="textRight" v-if="formData.drivingLicenseFile">{{formData.drivingLicenseFile}}</van-col>
            <van-col span="8" class="text" v-if="formData.drivingLicenseCore">证芯编号</van-col>
            <van-col span="16" class="textRight" v-if="formData.drivingLicenseCore">{{formData.drivingLicenseCore}}</van-col>
            <van-col span="24" class="text">行驶证</van-col>
            <van-col span="24" class="textImg">
              <img :src="formData.vehicleLicenseUrl" alt="">
            </van-col>
          </van-row>
        </div>
        <div class="orderInfo">
          <van-row>
            <van-col span="12" class="text">处罚金额</van-col>
            <van-col span="12" class="textRight">¥{{formData.punishAmount}}<span v-if="!formData.punishAmount" class="hidden">无</span></van-col>
            <van-col span="12" class="text">服务费</van-col>
            <van-col span="12" class="textRight">¥{{formData.serviceAmount}}<span v-if="!formData.serviceAmount" class="hidden">无</span></van-col>
            <van-col span="12" class="text">权益优惠</van-col>
            <van-col span="12" class="textRight">¥{{formData.rightDiscount}}<span v-if="!formData.rightDiscount" class="hidden">无</span></van-col>
            <van-col span="12" class="text">支付金额</van-col>
            <van-col span="12" class="textRight">¥{{formData.customerPay}}<span v-if="!formData.customerPay" class="hidden">无</span></van-col>
          </van-row>
        </div>
        <div class="content">
          <van-row>
            <van-col span="7" class="textNo">订单编号：</van-col>
            <van-col span="17" class="textVal textHeight">{{formData.orderNo}}</van-col>
            <van-col span="7" class="textNo"  v-if="formData.rechargeStatusName !== '待支付'">支付时间：</van-col>
            <van-col span="17" class="textVal textHeight"  v-if="formData.rechargeStatusName !== '待支付'">{{formData.paidTime}}</van-col>
            <van-col span="7" class="textNo" v-if="formData.rechargeStatusName === '已取消'">取消时间：</van-col>
            <van-col span="17" class="textVal textHeight" v-if="formData.rechargeStatusName === '已取消'">{{formData.cancelTime}}</van-col>
          </van-row>
        </div> 
        <div class="content" v-if="formData.rechargeStatusName === '已取消'">
          <van-row>
            <van-col span="7" class="textNo">退款总额：</van-col>
            <van-col span="17" class="textVal textHeight" style="color: #EA3F26;">￥{{formData.refundTotalAmount | formatFilter}}</van-col>
            <van-col span="7" class="textNo">权益金额：</van-col>
            <van-col span="17" class="textVal textHeight">￥{{formData.rightDiscount | formatFilter}}</van-col>
            <van-col span="7" class="textNo">在线支付：</van-col>
            <van-col span="17" class="textVal textHeight">￥{{formData.customerPay | formatFilter}}</van-col>
          </van-row>
        </div>
        <div class="info" v-if="formData.rechargeStatusName === '已取消' && formData.refundStatus === '1'">支付金额将在1-3个工作日内退回原支付账户</div>
      </div>

      <div class="btn" v-if="formData.rechargeStatusName === '待支付'">
        <van-button type="default" @click="cancelClick">取消订单</van-button>
        <van-button type="info" @click="submitClick">立即支付</van-button>
      </div>
    </div>
    
    <cancel-order ref="cancelOrder" @cancelClick="sureCancel"></cancel-order>
  </div>
</template>
<script>
import { carLifeOrderDetail, carLifePayPre } from "@/common/api.js";
import Pay from "@/common/weixin.js";
import CancelOrder from "@/components/cancel-order.vue";
import { debounce } from "lodash";
export default {
  name: "orderDetail",
  components: {
    CancelOrder
  },
  data() {
    return {
      formData: {}
    }
  },
  mounted() {
    this.init()
  },
  filters: {
    formatFilter(val) {
      if(isNaN(Number(val))) return '0.00'
      return Number(val).toFixed(2)
    }
  },
  methods: {
    init() {
      if (this.$route.query.orderNo) {
        let arr = this.$route.query.orderNo;
        if (Array.isArray(arr)) {
          this.orderNo = arr[arr.length - 1];
        } else {
          this.orderNo = this.$route.query.orderNo;
        }
      }
      // 支付回调过来的
      if (this.$route.query.isCallBack) {
        const newHref = window.location.href.replace(/&isCallBack=\d/, '')
        location.replace(newHref)
      }
      this.getOrderDetail();
    },
    async  getOrderDetail() {
      const res = await carLifeOrderDetail({orderNo: this.$route.query.orderNo})
      this.formData = res
    },
     //立即支付的
    submitClick: debounce(
      async function () {
        this.$toast.loading({
          message: "提交中",
          forbidClick: true,
          duration: 0,
        });
        try {
          const envMap = ["1", "1", "4"];
          //调起预支付接口成功后
          let prepayRs = await carLifePayPre({
            payType: envMap[this.$browserEnv], //支付环境
            orderNo: this.$route.query.orderNo,
          });
          this.prePayHandle(prepayRs);
        } catch (error) {}
        this.$toast.clear()
      },
      3000,
      { leading: true, trailing: false }
    ),
    prePayHandle(payload) {
      const _payload = {
        appId: payload.appId,
        timeStamp: payload.timeStamp,
        nonceStr: payload.nonceStr,
        package: payload.packageValue,
        signType: payload.signType,
        paySign: payload.paySign,
        prepayId: payload.prepayId,
        mwebUrl: payload.mwebUrl,
      };
      switch (this.$browserEnv) {
        case 0:
          Pay.mpPay(_payload, this.$route.query.orderNo);
          break;
        case 1:
          Pay.wxPay(_payload, this.init, this.init);
          break;
        case 2:
          Pay.browserPay(_payload.mwebUrl, this.$route.query.orderNo);
          break;
      }
    },
    cancelClick() {
      this.$refs.cancelOrder.init({ orderId: this.$route.query.orderNo });
    },
    sureCancel() {
      this.getOrderDetail();
    }
  }
}
</script>
<style scoped lang="scss">
.orderDetail{
  width: 100%;
  background: #F4F6F7;
  height: 100%;
  font-size: 0.32rem;
  font-family:'Microsoft YaHei';
  .orderConter{
    background: #fff;
    border-top: 0.3rem solid #F4F6F7;
    .header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0.4rem;
      height: 1rem;
      border-bottom: 1px solid #F4F6F7;
      .headerTit{
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      img{
        width: 0.8rem;
        height: 0.8rem;
        margin-right: 0.2rem;
      }
      .title{
        color: #383838;
        font-weight: 500;
      }
      .state{
        color: #383838;
      }
      .rechargeStatus{
        color: #3399FF;
      }
    }
    .orderBottom{
      padding: 0 0.4rem 1.2rem;
    }
    .orderInfo{
      background: #fff;
      padding: 0.1rem 0;
      // font-size: 0.3rem;
      color: #787878;
      border-top: 1px solid #F4F6F7;
      .textRight{
        text-align: right;
        color: #383838;
        line-height: 0.8rem;
        word-wrap: break-word;
        word-break: normal;
      }
      .textImg{
        img{
          width: 30vw;
        }
      }
      .hidden{
        visibility:hidden;
      }
      .text{
        line-height: 0.8rem;
      }
    }
    .content{
      padding: 0.1rem 0;
      border-top: 1px solid #F4F6F7;
      .textNo, .textVal{
        // height: 0.8rem;
        line-height: 0.8rem;
      }
      .textNo{
        color: #787878;
      }
      .textVal{
        color: #383838;
      }
      .textHeight{
        height: 0.8rem;
      }
      .hidden{
        visibility:hidden;
      }
    }
    .number{
      margin-top: 0.3rem;
      .num{
        font-weight: 500;
      }
    }
    .noBorder{
      border: none
    }
  }
  .info{
    font-size: 0.28rem;
    color: #EA3F26;
    padding: 0 0.3rem 1rem;
  }
  .btn{
    width: 100vw;
    padding: 0 0.4rem;
    box-sizing: border-box;
    height: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #f0f0f0;
    background: #fff;
    position: fixed;
    bottom: 0;
    /deep/ .van-button{
      border-radius: 0.16rem;
      padding: 0 1.01rem;
    }
  }
  .cancel {
    color: #4d7399;
    line-height: 1rem;
    font-size: 0.3rem;
    text-align: center;
  }
}
</style>